import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const bookingMarkAsCompletedAtom = createMutationAtomFactory(
  'trade.bookingMarkAsCompleted',
  (params: { id: string }) => ({
    tradeBookingComplete: {
      __args: {
        id: params.id,
      },
      id: true,
    },
  }),
);
